import React, { useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useJugadorEstadisticas } from '../../hooks/queries/useJugadorEstadisticas';
import { advancedComparisonCandidates } from '../../utils/advancedStatistics';
import { playerName } from '../../utils/playerRanking';

export default function AdvancedComparisonControls({ record, scope, selected, onSelect,
  minimumMinutes, onMinimumChange, eligible }) {
  const { t } = useTranslation('advanced');
  const query = useJugadorEstadisticas(record.idGrupo, record.idTemporada);
  const candidates = advancedComparisonCandidates(record, query.data, minimumMinutes, scope);
  const currentSelection = candidates.find(row => row.id === selected?.id) || null;
  useEffect(() => {
    if (!query.isLoading && !query.isError && selected !== currentSelection) onSelect(currentSelection);
  }, [query.isLoading, query.isError, selected, currentSelection, onSelect]);
  return <section className="as-comparison" aria-label={t('comparison.title')}>
    <h3>{t('comparison.title')}</h3>
    <p className="as-note">{t('comparison.method')}</p>
    <div className="as-comparison-fields">
      <TextField type="number" label={t('comparison.minimum')} value={minimumMinutes}
        onChange={event => onMinimumChange(event.target.value)} inputProps={{ min: 0, step: 1 }} />
      <Autocomplete options={candidates} value={currentSelection}
        onChange={(_, value) => onSelect(value)} disabled={!eligible}
        getOptionLabel={row => `${playerName(row)} · ${row.nombreEquipo || row.equipo || row.idEquipo}`}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={query.isLoading} loadingText={t('comparison.loading')} noOptionsText={t('comparison.empty')}
        clearText={t('comparison.clear')} openText={t('comparison.open')} closeText={t('comparison.close')}
        renderInput={params => <TextField {...params} label={t('comparison.player')} />} />
    </div>
    {!eligible && <p className="as-note" role="status">{t('comparison.belowMinimum')}</p>}
    {query.isLoading && <p className="as-note" role="status">{t('comparison.loading')}</p>}
    {query.isError && <p className="as-note" role="status">{t('comparison.error')} <button type="button"
      className="as-retry" onClick={() => query.refetch()}>{t('retry')}</button></p>}
  </section>;
}
